module.exports = __webpack_public_path__ + "static/media/ulster-university.563b77f8.png";